import {applyMiddleware, createStore} from 'redux'
import thunk from 'redux-thunk'

import rootReducer from 'shared/reducers'

export default (initialState = {}) => createStore(rootReducer, initialState, applyMiddleware(thunk));



// WEBPACK FOOTER //
// ./src/shared/store/store.prod.js